import BootstrapTable, { BootstrapTableProps } from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setCurrentPage, setTablePageSize } from '../../redux/actions';
import { ReactNode } from 'react';
import { formatOptions } from '../../utils/utils';
import { ReplacementType } from '../../types/AppTypes';

const { SearchBar } = Search;

const columns = [
  {
    dataField: 'replacementId',
    text: 'Id',
    hidden: true,
  },
  {
    dataField: 'pattern',
    text: 'Pattern',
    headerAlign: 'center',
    align: 'center',
    sort: true,
  },
  {
    dataField: 'replacement',
    text: 'Replacement',
    headerAlign: 'center',
    align: 'center',
    sort: true,
  },
  {
    dataField: 'category',
    text: 'Category',
    headerAlign: 'center',
    align: 'center',
    sort: true,
  },
  {
    dataField: 'order',
    text: 'Order',
    headerAlign: 'center',
    align: 'center',
    sort: true,
  },
  {
    dataField: 'username',
    text: 'Username',
    headerAlign: 'center',
    align: 'center',
    sort: true,
  },
  {
    dataField: 'created',
    text: 'Created',
    formatter: (cell: string): string => {
      const seconds = parseInt(cell, 10);
      const utcDate = new Date(seconds * 1000);

      const date = utcDate.toLocaleTimeString('en-US', formatOptions);

      return date;
    },
    headerAlign: 'center',
    align: 'center',
    sort: true,
  },
];

type Props = {
  replacements: ReplacementType[];
  onRowClick: (row: any) => void;
};

const ReplacementsTable = ({ replacements, onRowClick }: Props): JSX.Element => {
  const data = replacements && replacements.length ? replacements : [];
  const tablePageSize = useAppSelector((state) => state.replacements.tablePageSize);
  const currentPage = useAppSelector((state) => state.replacements.currentPage);
  
  const rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      onRowClick(row);
    }
  };

  const pagination = paginationFactory({
    sizePerPage:parseInt(localStorage.getItem('replacements-table-size') || '', 10) || tablePageSize,
    page: currentPage,
    onPageChange: (page) => {
      dispatch(setCurrentPage(page));
    },
    onSizePerPageChange: (sizePage) => {
      sizePerPageReplacementsChange(sizePage)
      dispatch(setTablePageSize(sizePage));
  }});


  const sizePerPageReplacementsChange = (sizePerPage: number) =>{
    localStorage.setItem('replacements-table-size',sizePerPage.toString())
  }

  const dispatch = useAppDispatch();
  return (
    <div style={{ marginBottom: '15px' }}>
       <ToolkitProvider
        keyField="pattern"
        data={data}
        columns={columns}
        striped
        hover
        condensed
        rowStyle={{cursor: "pointer"}}
        sort={{ dataField: 'created', order: 'desc' }}
        search
      >
      {
          (props: { searchProps: JSX.IntrinsicAttributes; baseProps: JSX.IntrinsicAttributes & JSX.IntrinsicClassAttributes<BootstrapTable<any, number>> & Readonly<BootstrapTableProps<any, number>> & Readonly<{ children?: ReactNode; }>; }) => (
          <div>
            <SearchBar { ...props.searchProps } />
            <hr />
            <BootstrapTable
              { ...props.baseProps }
              pagination={pagination}
              rowEvents={ rowEvents }
            />
          </div>
        )
      }
      </ToolkitProvider>
    </div>
  );
};

export default ReplacementsTable;